import { render, staticRenderFns } from "./WorkspacePhotoEditor.vue?vue&type=template&id=42775294&scoped=true&"
import script from "./WorkspacePhotoEditor.vue?vue&type=script&lang=js&"
export * from "./WorkspacePhotoEditor.vue?vue&type=script&lang=js&"
import style0 from "./WorkspacePhotoEditor.vue?vue&type=style&index=0&id=42775294&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42775294",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42775294')) {
      api.createRecord('42775294', component.options)
    } else {
      api.reload('42775294', component.options)
    }
    module.hot.accept("./WorkspacePhotoEditor.vue?vue&type=template&id=42775294&scoped=true&", function () {
      api.rerender('42775294', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Workspace/WorkspacePhotoEditor.vue"
export default component.exports